import React, { useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import ProductCard from "../components/ProductCard";
import { Rating } from "react-simple-star-rating";
import ReactImageZoom from "react-image-zoom";
import Color from "../components/Color";
import { TbGitCompare } from "react-icons/tb";
import { AiOutlineHeart } from "react-icons/ai";
import Container from "../components/Container";

const SingleProduct = () => {
  const props = {
    width: 400,
    height: 500,
    zoomWidth: 600,

    img: "https://images.pexels.com/photos/280250/pexels-photo-280250.jpeg?cs=srgb&dl=pexels-pixabay-280250.jpg&fm=jpg",
  };

  const [orderedProduct, setorderedProduct] = useState(true);
  const copyToClipboard = (text) => {
    console.log("text", text);
    var textField = document.createElement("textarea");
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
  };
  return (
    <>
      <Meta title={"Product Name"} />
      <BreadCrumb title="Product name" />
      <Container class1="main-product-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-6">
            <div className="main-product-image">
              <div>
                <ReactImageZoom {...props} />
              </div>
            </div>
            <div className="other-product-images d-flex flex-wrap gap-15">
              <div>
                <img
                  src="https://www.fastrack.in/dw/image/v2/BKDD_PRD/on/demandware.static/-/Sites-titan-master-catalog/default/dw4719f5ec/images/Fastrack/Catalog/3287KL01_2.jpg?sw=600&sh=600"
                  alt="wrist-watch"
                  className="img-fluid"
                />
              </div>
              <div>
                <img
                  src="https://www.fastrack.in/dw/image/v2/BKDD_PRD/on/demandware.static/-/Sites-titan-master-catalog/default/dw4719f5ec/images/Fastrack/Catalog/3287KL01_2.jpg?sw=600&sh=600"
                  alt="wrist-watch"
                  className="img-fluid"
                />
              </div>
              <div>
                <img
                  src="https://www.fastrack.in/dw/image/v2/BKDD_PRD/on/demandware.static/-/Sites-titan-master-catalog/default/dw4719f5ec/images/Fastrack/Catalog/3287KL01_2.jpg?sw=600&sh=600"
                  alt="wrist-watch"
                  className="img-fluid"
                />
              </div>
              <div>
                <img
                  src="https://www.fastrack.in/dw/image/v2/BKDD_PRD/on/demandware.static/-/Sites-titan-master-catalog/default/dw4719f5ec/images/Fastrack/Catalog/3287KL01_2.jpg?sw=600&sh=600"
                  alt="wrist-watch"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="main-product-details">
              <div className="border-bottom">
                <h3 className="title">
                  Kids headphones bulk 10 pack multi-colored for students
                </h3>
              </div>
              <div className="border-bottom py-3">
                <p className="price">$ 100</p>
                <div className="d-flex align-items-center gap-10">
                  <Rating
                    initialValue={4.5}
                    allowFraction={true}
                    readonly={true}
                    size={24}
                    fillColor="#ffd700"
                    emptyColor="#ccc"
                  />
                  <p className="mb-0 t-review">(2 reviews)</p>
                </div>
                <a className="review-btn" href="#review">
                  Write a review
                </a>
              </div>
              <div className="py-3">
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Type :</h3>
                  <p className="product-data">Watch</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Brand :</h3>
                  <p className="product-data">Casio</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2">
                  <h3 className="product-heading">Category :</h3>
                  <p className="product-data">Watch</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2 ">
                  <h3 className="product-heading">Tags :</h3>
                  <p className="product-data">Watch</p>
                </div>
                <div className="d-flex gap-10 align-items-center my-2 ">
                  <h3 className="product-heading">Availability :</h3>
                  <p className="product-data">In stock</p>
                </div>
                <div className="d-flex gap-10 flex-column mt-2 mb-3 ">
                  <h3 className="product-heading">Size :</h3>
                  <div className="d-flex flex-wrap gap-15">
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      S
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      M
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      L
                    </span>
                    <span className="badge border border-1 bg-white text-dark border-secondary">
                      XL
                    </span>
                  </div>
                </div>
                <div className="d-flex gap-10 flex-column mt-2 mb-3 ">
                  <h3 className="product-heading">Color :</h3>
                  <Color />
                </div>
                <div className="d-flex align-items-center gap-15 flex-row mt-2 mb-3 ">
                  <h3 className="product-heading">Quantity :</h3>
                  <div className="">
                    <input
                      type="number"
                      name=""
                      min={1}
                      max={10}
                      className="form-control"
                      style={{ width: "70px" }}
                    />
                  </div>
                  <div className="d-flex align-items-center gap-30 ms-5">
                    <button className="button border-0 " type="submit">
                      Add to cart
                    </button>
                    <button className="button signup">Buy it now</button>
                  </div>
                </div>
                <div className="d-flex align-items-ccenter gap-15">
                  <div>
                    <a href="">
                      <TbGitCompare className="fs-5 me-2" />
                      Add to compare
                    </a>
                  </div>
                  <div>
                    <a href="">
                      <AiOutlineHeart className="fs-5 me-2" />
                      Add to wishlist
                    </a>
                  </div>
                </div>
                <div className="d-flex gap-10 flex-column my-3">
                  <h3 className="product-heading">Shipping & returns :</h3>
                  <p className="product-data">
                    Free shipping and returns available on all orders!
                    <br />
                    We ship all us domestic orders within
                    <b>5-10 business days!</b>
                  </p>
                </div>
                <div className="d-flex gap-10 align-items-center my-3">
                  <h3 className="product-heading">Copy product link:</h3>
                  <a
                    href="#"
                    onClick={() => {
                      copyToClipboard(
                        "https://images.pexels.com/photos/280250/pexels-photo-280250.jpeg?cs=srgb&dl=pexels-pixabay-280250.jpg&fm=jpg"
                      );
                    }}
                  >
                    Copy product link
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container class1="description-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h4>Description</h4>
            <div className="bg-white p-3">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
                euismod nisi et massa vehicula posuere. Nam eget enim
                consectetur, fringilla sapien non, volutpat neque. In dapibus
                scelerisque justo a maximus. Suspendisse a ante orci. Donec elit
                felis, cursus ut egestas eu, auctor eget libero. Etiam tempus
                tortor in molestie dictum. Nam quis efficitur elit. Vivamus sed
                nibh mollis felis finibus mattis. Suspendisse vestibulum maximus
                facilisis. Curabitur bibendum massa sed dapibus dapibus. Fusce
                rutrum mattis turpis quis aliquet.
              </p>
            </div>
          </div>
        </div>
      </Container>
      <Container class1="reviews-wrapper home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 id="review">Reviews</h3>
            <div className="review-inner-wrapper">
              <div className="review-head d-flex justify-content-between align-items-end">
                <div>
                  <h4 className="mb-2">Customer reviews</h4>
                  <div className="d-flex align-items-center gap-10">
                    <Rating
                      initialValue={4.5}
                      allowFraction={true}
                      readonly={true}
                      size={24}
                      fillColor="#ffd700"
                      emptyColor="#ccc"
                    />
                    <p className="mb-0">Based on 2 reviews</p>
                  </div>
                </div>
                {orderedProduct && (
                  <div>
                    <a
                      className="text-dark text-decoration-underline"
                      href="www.github.com"
                    >
                      Write a review
                    </a>
                  </div>
                )}
              </div>
              <div className="review-form py-4">
                <h4>Write a review</h4>
                <form action="" className="d-flex flex-column gap-15">
                  <div>
                    <Rating
                      initialValue={4.5}
                      allowFraction={true}
                      readonly={false}
                      size={24}
                      fillColor="#ffd700"
                      emptyColor="#ccc"
                    />
                  </div>
                  <div>
                    <textarea
                      name=""
                      id=""
                      className="w-100 form-control"
                      cols="38"
                      rows=""
                      placeholder="Comments"
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button className="button border-0">Submit review</button>
                  </div>
                </form>
              </div>
              <div className="reviews mt-4">
                <div className="review">
                  <div className="d-flex gap-10 align-items-center">
                    <h6 className="mb-0">Masimba</h6>
                    <Rating
                      initialValue={4.5}
                      allowFraction={true}
                      readonly={true}
                      size={24}
                      fillColor="#ffd700"
                      emptyColor="#ccc"
                    />
                  </div>
                  <p className="mt-3 ">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Proin euismod nisi et massa vehicula posuere. Nam eget enim
                    consectetur, fringilla sapien non, volutpat neque. In
                    dapibus scelerisque justo a maximus. Suspendisse a ante
                    orci. Donec elit felis, cursus ut egestas eu, auctor eget
                    libero. Etiam tempus tortor in molestie dictum. Nam quis
                    efficitur elit. Vivamus sed nibh mollis felis finibus
                    mattis. Suspendisse vestibulum maximus facilisis. Curabitur
                    bibendum massa sed dapibus dapibus. Fusce rutrum mattis
                    turpis quis aliquet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Container class1="popular-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <h3 className="section-heading">Our popular products</h3>
          </div>
        </div>
        <div className="row">
          <ProductCard />
        </div>
      </Container>
    </>
  );
};

export default SingleProduct;
